import { ICmsNewsList, INewsList } from "./news";

export interface ITimelineNewsResponse {
  News: INewsList[];
  Total: number;
}

export interface ITimelineEventsResponse {
  Events: INewsList[];
  Total: number;
}

export interface ITimelineCmsNewsResponse {
  news: ICmsNewsList[];
  total: number;
}


